import { flow, omit, size } from 'lodash/fp';

import { PAGE_NAME, SORT_NAME } from '../constants';
import { EXTRA_FILTERS_QUERY_KEY } from './constants';

export default flow(
  omit([PAGE_NAME, SORT_NAME, EXTRA_FILTERS_QUERY_KEY]),
  size,
  Boolean,
);
